import { useState } from "react";
import Image from "next/image";

import { SVGSprite } from "@/components/Atoms";

import BookingAndCancelFlow from "./BookingAndCancelFlow";
import SingleClassPurchaseFlow from "./SingleClassPurchaseFlow";
import ClassListPurchaseFlow from "./ClassListPurchaseFlow";

const SessionCard: React.FC<any> = (props) => {
  const {
    time,
    date,
    title,
    description,
    location,
    googleMapLink,
    classDetail,
    encodedId,
    onboardId,
    centerId,
    centerTiming,
    centerName,
    thumbnail,
    isSingleClassPurchasePage,
    isClassListPurchasePage,
    shyftPassLogo,
    ...rest
  } = props || {};

  const {
    difficultyLevel,
    difficultyLevelColor,
    hasParking,
    hasParkingColor,
    attire,
    attireColor,
    classDetails,
    slotBookedStatus,
    bookingId,
    hasAllSlotsBooked,
  } = classDetail || {};

  const [isClassDetailOpen, setIsClassDetailOpen] = useState(false);

  return (
    <>
      <div className="sessionCard">
        <div className="thumbnail">
          <Image
            src={
              thumbnail ||
              "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
            }
            alt={title || "workout-session"}
            fill={true}
          />
          {shyftPassLogo && (
            <div className="shyftLogo">
              <Image
                src={
                  shyftPassLogo ||
                  "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-06/Logoshyft_pass_logo_1-cdf5f66dbccb451fb47634a8ce9f22cf.png"
                }
                alt="shyft pass logo"
                fill={true}
              />
            </div>
          )}
        </div>
        <div className="sessionData">
          <div className="dateTime">
            <div className="sessionTime">{time}</div>
            <div className="separator">|</div>
            <div className="sessionDate">{date}</div>
          </div>
          <div className="title">{title}</div>
          <div className="description">{description}</div>
          <div className="location">
            <a
              className="location"
              href={googleMapLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {`${centerName} - ${location}`}
            </a>
          </div>
        </div>
      </div>
      <div className="detail-section">
        <div className="detail-top-section">
          {isClassDetailOpen && (
            <div className="workout-session-detail">
              <div
                className="class-detail"
                dangerouslySetInnerHTML={{ __html: classDetails }}
              />
            </div>
          )}
          <div className="workout-session-info">
            <div className="level">
              <p className="title">Level</p>
              <p
                className="description"
                style={{ color: difficultyLevelColor }}
              >
                {difficultyLevel}
              </p>
            </div>
            <div className="parking">
              <p className="title">PARKING</p>
              <p className="description" style={{ color: hasParkingColor }}>
                {hasParking}
              </p>
            </div>
            <div className="attire">
              <p className="title">Attire</p>
              <p className="description" style={{ color: attireColor }}>
                {attire}
              </p>
            </div>
          </div>
        </div>
        {classDetails && (
          <div
            className="view-class-detail-cta"
            onClick={() => {
              setIsClassDetailOpen(!isClassDetailOpen);
            }}
          >
            <p className="cta">
              {isClassDetailOpen ? "Close class details" : "View class details"}
            </p>

            <SVGSprite
              className={`icon ${isClassDetailOpen ? "open" : ""}`}
              icon="icon-slider-arrow-left"
              height="24px"
              width="24px"
            />
          </div>
        )}
      </div>
      {isSingleClassPurchasePage ? (
        <SingleClassPurchaseFlow />
      ) : isClassListPurchasePage ? (
        <ClassListPurchaseFlow {...props} />
      ) : (
        <BookingAndCancelFlow
          encodedId={encodedId}
          onboardId={onboardId}
          centerId={centerId}
          slotBookedStatus={slotBookedStatus}
          bookingId={bookingId}
          hasAllSlotsBooked={hasAllSlotsBooked}
          centerTiming={centerTiming}
          title={title}
          {...rest}
        />
      )}
    </>
  );
};

export default SessionCard;
